<div class="p-10 w-full">
  <div class="flex flex-col justify-center items-center gap-8">
    <span i18n>Something has gone wrong!</span>
    <div class="flex flex-row justify-center items-center gap-4">
      <button *ngIf="refresh || retry" type="button" (click)="triggerRetry()" [disabled]="retryInProgress() || resetInProgress()" mat-stroked-button>
        <span class="flex flex-row items-center gap-4">
          <span i18n>Retry</span>
          <mat-spinner *ngIf="retryInProgress()" [diameter]="15"></mat-spinner>
        </span>
      </button>
      <button *ngIf="reset" type="button" (click)="triggerReset()" [disabled]="resetInProgress() || retryInProgress()" mat-stroked-button>
        <span class="flex flex-row items-center gap-4">
          <span i18n>Reset</span>
          <mat-spinner *ngIf="resetInProgress()" [diameter]="15"></mat-spinner>
        </span>
      </button>
    </div>
    <span *ngIf="isNotRelease" class="text-red-700">{{errorMessage()}}</span>
  </div>
</div>
